import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import {
    FertilizerProductUnits,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';

import { selectTotalArea, selectTotalTrees } from '../../../../selectors';
import { Props } from './index';

const selectUnits = (state: AppState, props: Props): FertilizerProductUnits =>
    (props.product && props.product.units) || 0;

const selectPerUnitType = (
    state: AppState,
    props: Props
): FertilizerProductPerUnitType => props.perUnitType;

const selectProductTotal = createDeepEqualSelector(
    selectUnits,
    selectTotalArea,
    selectTotalTrees,
    makeSelectUnitTypeFieldValue('name'),
    selectPerUnitType,
    (units, totalArea, totalTrees, unitTypeName, perUnitType) => {
        let productTotal: number;

        if (perUnitType === 'Ha') {
            productTotal = Number(units * totalArea);
        } else {
            productTotal = Number(units * totalTrees);
        }

        return `${productTotal.toFixed(2)} ${unitTypeName || ''}`;
    }
);

const makeSelectProductTotal = (): typeof selectProductTotal =>
    selectProductTotal;

export { makeSelectProductTotal };
